export default __webpack_public_path__ + "static/Banner-9ed270750afaf73f5ac3304c288b2398.jpg";